import type { DesignBuildPlanSeed } from '@volley/crucible-ipc-types';

/**
 * Drives the Design-Wizard/manual "Start building" handoff. Throws when the
 * kickoff is declined or fails so the caller's plan error toast surfaces.
 */
export async function runDesignStartBuild(args: {
  sendStartBuildingKickoff: (source: 'user', seededPlan?: DesignBuildPlanSeed) => Promise<boolean>;
  seededPlan?: DesignBuildPlanSeed;
}): Promise<void> {
  const ok = await args.sendStartBuildingKickoff('user', args.seededPlan);
  if (!ok) {
    throw new Error('Build kickoff did not complete. Check the plan error toast and try again.');
  }
}
